import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { IStateService } from 'src/app/services/state/state.service.interface';
import { ICountryService } from "../../services/country/country.service.interface";

@Component({
  selector: 'app-org-address',
  template: `
    <div class="wrapper">
        <div class="country">
          <label for="country">Country</label>
          <select id="country" [formControl]="formGroup.controls['country']">
            <option value="" selected disabled>Country</option>
            <ng-container *ngFor="let c of CountryService.GetAllCountries()">
              <option *ngIf="c.Name != '' && c.Name != 'NOT DEFINED'" value="{{ c.Code }}">{{ c.Name }}</option>
            </ng-container>
          </select>
        </div>

        <div class="streetSuite" *ngIf="CountryService.RequireAddress(formGroup.controls['country'].value)">
          <div class="street">
            <app-default-text-input [max]="95" [label]="'Street'" [id]="'street'" [autocomplete]="'street-address'" [control]="formGroup.controls['street']" [placeholder]="'1234 Main St'"></app-default-text-input>
          </div>
          <div class="suite">
            <app-default-text-input [max]="95" [label]="'Suite'" [id]="'suite'" [autocomplete]="'address-line2'" [control]="formGroup.controls['suite']" [placeholder]="'100'"></app-default-text-input>
          </div>
        </div>

        <div *ngIf="CountryService.RequireAddress(formGroup.controls['country'].value)" class="city">
          <app-default-text-input [max]="45" [label]="'City'" [id]="'city'" [autocomplete]="'address-level2'" [control]="formGroup.controls['city']" [placeholder]="'Sunnyvale'"></app-default-text-input>
        </div>

        <div class="stateZip" *ngIf="CountryService.RequireAddress(formGroup.controls['country'].value)">
        <div class="state">
        <label for="state">State <i  class="fas fa-asterisk center red-icon"></i></label>  
        <select id="state" [formControl]="formGroup.controls['state']">
          <option value="" selected ></option>
          <ng-container *ngFor="let c of StateService.GetAllState()">
            <option *ngIf="c.Name != '' && c.Name != 'NOT DEFINED'" value="{{ c.Code }}">{{ c.Name }}</option>
          </ng-container>
        </select>
        <span *ngIf="formGroup.get('state').hasError('required') && formGroup.get('state').touched" class='errors' padding>Required</span>

      </div>
      
          <div class="zip">
            <app-default-text-input [max]="11" [label]="'Zip'" [id]="'zip'" [autocomplete]="'postal-code'" [control]="formGroup.controls['zip']" [placeholder]="'94000'"></app-default-text-input>
          </div>
        </div>
    </div>
  `,
  styleUrls: ['./organization-address.component.scss']
})
export class OrgAddressComponent implements OnInit {

  CountryService: ICountryService;
  StateService: IStateService;
  formGroup: FormGroup;
  @Output() onCreateForm: EventEmitter<FormGroup>;

  constructor(CountryService: ICountryService, StateService:IStateService, fb: FormBuilder) {
    this.CountryService = CountryService;
    this.StateService = StateService;
    this.onCreateForm = new EventEmitter<FormGroup>();
    this.formGroup = fb.group({
      country: new FormControl("USA", [Validators.required]),
      street: new FormControl("", [Validators.required]),
      suite: new FormControl("", []),
      city: new FormControl("", [Validators.required]),
      state: new FormControl("", [Validators.required]),
      zip: new FormControl("", [Validators.required])
    });
    this.formGroup.controls['country'].valueChanges.subscribe((val) => {this.onCountryChanged(val)});
  }

  onCountryChanged(val: any) {
    if(this.CountryService.RequireAddress(val)) {
      this.formGroup.controls['street'].setValidators([Validators.required]);
      this.formGroup.controls['street'].updateValueAndValidity()
      this.formGroup.controls['city'].setValidators([Validators.required]);
      this.formGroup.controls['city'].updateValueAndValidity()
      this.formGroup.controls['state'].setValidators([Validators.required]);
      this.formGroup.controls['state'].updateValueAndValidity()
      this.formGroup.controls['zip'].setValidators([Validators.required]);
      this.formGroup.controls['zip'].updateValueAndValidity()
    } else {
      this.formGroup.controls['street'].setValidators([]);
      this.formGroup.controls['street'].updateValueAndValidity()
      this.formGroup.controls['city'].setValidators([]);
      this.formGroup.controls['city'].updateValueAndValidity()
      this.formGroup.controls['state'].setValidators([]);
      this.formGroup.controls['state'].updateValueAndValidity()
      this.formGroup.controls['zip'].setValidators([]);
      this.formGroup.controls['zip'].updateValueAndValidity()
    }
  }

  ngOnInit() {
    this.onCreateForm.emit(this.formGroup);
  }

}
